<template>
    <div>
        <Card :bordered="false">
            <DatePicker type="year" placeholder="选择年份" format="yyyy" style="width: 200px" v-model="Search.CurrentYear" :clearable="false"></DatePicker>
            <ButtonGroup v-model="Search.SelectYear" style="margin-left:10px;">
                <Button @click="ChangeYear('prevYear')" :type="Search.SelectYear=='prevYear'?'primary':'default'">上一年</Button>
                <Button @click="ChangeYear('thisYear')" :type="Search.SelectYear=='thisYear'?'primary':'default'">本年度</Button>
                <Button @click="ChangeYear('nextYear')" :type="Search.SelectYear=='nextYear'?'primary':'default'">下一年</Button>
            </ButtonGroup>
            <span style="margin-left:20px;margin-right:5px;">选择户号</span>
            <Select v-model="Search.S_CID"  style="width: 200px">
                <Option v-for="item in Search.ScidDataList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Button @click="SearchFee" type="primary" style="margin-left:10px;">查询</Button>
        </Card>

        <Table  :columns="FormValidate.ColumnsValue" :data="FormValidate.FormData" size="small" no-data-text="暂无数据" :row-class-name="rowClassName"></Table>

        <div class="descAlert" v-show="FormValidate.QianFei">
            <p>提示：列表中如有绿色背景则该条为当前账期欠费</p>
        </div>

        <div  style="text-align: right;margin:1rem 0;" v-show="FormValidate.QianFei">
            <span style="margin-right: 1rem;">当前欠费金额：{{FormValidate.N_QianFeiJE}}元</span>
            <Button @click="AccountPay" type="error">合计支付</Button>
        </div>

        <Modal v-model="Ladder.LadderModal" title="阶梯详情" footer-hide class-name="vertical-center-modal">
            <Table :columns="Ladder.ColumnsValue" :data="Ladder.FormData" class="ladderTable"></Table>
        </Modal>

        <Modal title="缴费二维码" v-model="QRcodeModal" footer-hide width="300" height="300">
            <img :src="QRcode" style="width:100%;">
            <p style="text-align: center">*请使用微信扫一扫</p>
        </Modal>
        <Modal title="选择发票下载类型" v-model="FaPiaoLeiX" footer-hide width="300" height="300">
            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                <Button type="primary" style="margin-bottom: 20px;" v-show="OFDbTn" @click="downloadInvoice('002')">下载普票</Button>
                <Button type="primary" style="margin-bottom: 20px;" v-show="PDFbTn" @click="downloadInvoice('001')">下载专票</Button>
            </div>
        </Modal>
        <Spin size="large" fix v-if="SpinShow"></Spin>
    </div>
</template>

<script>
    import {ButtonGroup} from 'view-design';
    export default {
        name: "WaterFee",
        components:{
            ButtonGroup
        },
        data(){
            return{
                Search:{
                    S_CIDList:[],
                    S_CID:"",
                    SelectYear:'thisYear',
                    CurrentYear:''
                },
                FormValidate:{
                    ColumnsValue:[
                        {title: '户名',key: 'S_HM',align: 'center'},
                        {title: '水费年月',key: 'I_ZhangWuNY',align: 'center'},
                        {title: '用水量',key: 'I_SL',align: 'center'},
                        {title:'上次抄码',key:'I_ShangCiCM',align:'center'},
                        {title:'本次抄码',key:'I_BenCiCM',align:'center'},
                        {title:'账单金额',key:'N_JE',align:'center'},
                        {title: '操作',align: 'center',
                            render: (h, params) => {
                                if (!params.row) {return false;}
                                // let _btnName=["查看阶梯"];
                                let _btnName=[];
                                ([params.row]).forEach((item)=>{
                                    if(item.I_KPZT==0){
                                        _btnName.push("申请发票");
                                    }
                                    if(item.I_KPZT==1){
                                        _btnName.push("下载发票");
                                    }
                                });
                                let _button=[];
                                _btnName.forEach((item)=>{
                                    _button.push(h('Button', {
                                        props: {size: 'small'},
                                        style: {
                                            borderColor: "#46AEFD",background: "#8FC6EF",color:"#222",fontSize: "0.8rem",
                                            marginBottom:'5px',marginTop:'5px',marginLeft:'5px',display: "inline-block",textAlign:"center"},
                                        on: {
                                            click: () => {
                                                this.DialogOpen(params.row,item)
                                            }
                                        }
                                    }, item));
                                });
                                return h('div', _button)
                            }
                        }],
                    FormData:[],
                    QianFei:false,
                    N_QianFeiJE:"",
                },
                Ladder:{
                    LadderModal:false,
                    ColumnsValue:[{title: '阶梯',key: 'S_JieTiMC',align: 'center'},
                        {title: '单价',key: 'N_DJ',align: 'center'},
                        {title: '用水量',key: 'I_SL',align: 'center'},
                        {title: '金额',key: 'N_JieTiJE',align: 'center'}],
                    FormData:[]
                },
                UserList:{
                    ColumnsValue:[{title: '户号',key: 'CustomerNO',align: 'center'},
                        {title: '户名',key: 'N_DJ',align: 'center'},
                        {title: '地址',key: 'I_SL',align: 'center'},
                        {title: '联系电话',key: 'CellPhone',align: 'center'}],
                    FormData:[]
                },
                QRcode:"",
                CurrentScid:"",
                QRcodeModal:false,
                SpinShow:false,
                ColumnsValueShow:true,
                FaPiaoLeiX:false,//发票类型 弹层
                PDFbTn:false,
                OFDbTn:false,
                OpenPDFUrl :[],
                OpenOFDUrl : [],
            }
        },
        mounted() {
            this.Search.SelectYear="thisYear";
            this.Search.CurrentYear=new Date();
            this.GetUserList();
        },
        methods:{
            ChangeYear(item){
                this.Search.SelectYear=item;
                let _date=this.Search.CurrentYear;
                switch (item) {
                    case "prevYear":
                        _date.setFullYear(_date.getFullYear()-1);
                        this.Search.CurrentYear=new Date(_date);
                        break;
                    case "thisYear":
                        this.Search.CurrentYear=new Date();
                        break;
                    case "nextYear":
                        _date.getFullYear()==new Date().getFullYear()?new Date().getFullYear():_date.setFullYear(_date.getFullYear()+1);
                        this.Search.CurrentYear=new Date(_date);
                        break;
                    default:
                        break;
                }
                this.SearchFee();
            },
            GetUserList(){
                let that=this;
                that.SpinShow=true;
                that.Search.ScidDataList=[];
                that.InApi("api/WaterBill/WaterBill/GetUserList", {OpenID: 1},"get").then(response => {
                    that.SpinShow=false;
                    if(response.length<=0)return false;
                    let _data=response;
                    _data.forEach(n=> that.Search.ScidDataList.push({label:n.CustomerNO,value:n.CustomerNO}));
                    that.Search.S_CID=_data[0].CustomerNO;
                    that.SearchFee();
                });
            },
            SearchFee(){
                let that=this;
                let _date=that.Search.CurrentYear;
                let _Month = (new Date()).getMonth();
                let _currentMonth= _Month < 10 ? "0" + (_Month + 1) : (_Month + 1);
                if (parseInt(_date.getFullYear()) < (new Date()).getFullYear()) { _currentMonth="12"}
                let data={
                    // Year:_date.getFullYear().toString(),
                    UserNo: that.Search.S_CID,
                    starTime: _date.getFullYear().toString()+"01",
                    endTime: _date.getFullYear().toString()+_currentMonth
                };
                that.SpinShow=true;
                that.FormValidate.FormData=[];
                that.InApi("api/WaterBill/WaterBill/GetWaterBillInfo", data,"get").then(response => {
                    that.SpinShow=false;
                    if(!response)return false;
                    let _data=JSON.parse(response);
                    let _res=[];
                    //20250429由于2024年后台改了预存功能，前端此处需要判断如果有账单信息则显示账单，如果没有则判断欠费信息并显示xiaohang
                    if(_data.S_ZhangDanXX.length>0){
                        _data.S_ZhangDanXX.forEach(function(item){
                            _res.push({
                                S_HM:item.S_HM,
                                I_ZhangWuNY:item.I_ZhangWuNY,
                                I_SL:item.I_SL,
                                I_ShangCiCM:item.I_ShangCiCM,
                                I_BenCiCM:item.I_BenCiCM,
                                N_JE:item.N_JE,
                                I_FeeID:item.I_FeeID,
                                I_KPZT:item.I_KPZT,
                                I_XiaoZhang:item.I_XiaoZhang,
                            });
                        });
                    }else if(_data.S_QianFeiXX.length>0){
                        _data.S_QianFeiXX.forEach(function(item){
                            _res.push({
                                S_HM:item.S_HM,
                                I_ZhangWuNY:item.I_ZhangWuNY,
                                I_SL:item.I_SL,
                                I_ShangCiCM:item.I_ShangCiCM,
                                I_BenCiCM:item.I_BenCiCM,
                                N_JE:item.N_JE,
                                I_FeeID:item.I_FeeID,
                                I_KPZT:item.I_KPZT,
                                I_XiaoZhang:item.I_XiaoZhang,
                            });
                        });
                    }
                    
                    _res.forEach(function(item,index){
                        _res[index]["S_HM"]=_data.S_HM;
                    });
                    that.FormValidate.FormData=_res;
                    that.CurrentScid=that.Search.S_CID;
                    _data.N_QianFeiJE>0?that.FormValidate.QianFei=true:that.FormValidate.QianFei=false;
                    _data.N_QianFeiJE>0?that.FormValidate.N_QianFeiJE=(_data.N_QianFeiJE).toFixed(2):that.FormValidate.N_QianFeiJE="";
                });
            },
            DialogOpen(row,item){
                switch (item) {
                    case "查看阶梯":
                        this.CheckLadder(row.I_FeeID,row.I_ZhangWuNY);
                        break;
                    case "申请发票":
                        this.KaiPiao(this.CurrentScid,row.I_ZhangWuNY,row.I_FeeID);
                        break;
                    case "下载发票":
                        this.KaiPiao(this.CurrentScid,row.I_ZhangWuNY,row.I_FeeID);
                        break;
                    default:
                        break;
                }
            },
            CheckLadder(I_FeeID,I_ZhangWuNY){
                let that=this;
                that.InApi("api/WaterBill/WaterBill/GetWaterBillDetail",{FeeID: I_FeeID, YM: I_ZhangWuNY},"get").then(function (response) {
                    if(!response)return false;
                    let _data =JSON.parse(response);
                    that.Ladder.LadderModal=true;
                    // that.Ladder.FormData=_data.filter(n=>n.I_SL>0);
                    that.Ladder.FormData=_data;
                });
            },
            KaiPiao(S_CID, I_ZhangWuNY, I_FEEID) {
                let that=this;
                that.SpinShow=true;
                // let _i = 0;
                // var timeout = setInterval(function () {
                //     var _URL;
                //     that.OpenInvice(S_CID, I_ZhangWuNY, I_FEEID).then(function(response){
                //         _URL=response;
                //         console.log(_URL);
                //         _i++;
                //         if (_URL != "null" && _URL != "error" && _URL != "") {
                //             that.SpinShow=false;
                //             let result = JSON.parse(_URL);
                //             let _pdfurl=result.PdfUrl;
                //             window.open(_pdfurl);
                //             clearInterval(timeout);
                //         }
                //         if (_URL == "error") {
                //             that.SpinShow=false;
                //             that.$Notice.error({title:'提示',desc: "开票失败!请稍候再试!"});
                //             clearInterval(timeout);
                //         }
                //         if (_i >= 6) {
                //             that.SpinShow=false;
                //             that.$Notice.error({title:'提示',desc: "开票失败!请稍候再试!"});
                //             clearInterval(timeout);
                //         }
                //     });
                // }, 5000);
                that.InApi("api/Invoice/Invoice/GetInvoiceInfo2024",{S_CID: S_CID, I_ZhangWuNY: I_ZhangWuNY, I_FEEID: I_FEEID},"get",{ timeout: 10000 }).then(function (response) {
                    that.SpinShow=false;
                    if(!response)return false;
                    let ResData = response;
                    console.log(ResData,"ResData");
                    if (ResData.ReturnCode==false) {
                        that.$Notice.error({title:'提示',desc: "开票失败，请于24小时后再试"});
                        return false;
                    }
                    if (ResData.length<=0) {
                        that.$Notice.error({title:'提示',desc: "开票失败，请于24小时后再试"});
                        return false;
                    }
                    //多张发票
                    that.OpenPDFUrl=[],that.OpenOFDUrl=[];
                    if(ResData.length>1){
                        that.FaPiaoLeiX = true;
                        ResData.forEach(n => {
                            //002是普票 001是专票
                            if(n.FPLXDM=="002"){
                                 that.OpenPDFUrl.push(n.URL);
                            }else if(n.FPLXDM=="001"){
                                 that.OpenOFDUrl.push(n.URL);
                            }                                                     
                        })
                        console.log(that.OpenPDFUrl,"that.OpenPDFUrl");
                        console.log(that.OpenOFDUrl,"that.OpenOFDUrl");
                        if(that.OpenPDFUrl.length>0){
                            
                            that.OFDbTn = true;
                        }
                        if(that.OpenOFDUrl.length>0){                   
                            that.PDFbTn = true;
                        }
                    }else{
                        ResData.forEach(n => {
                            console.log(n);
                        let OpenUrl = n.URL;
                        console.log(OpenUrl,"URL");
                        window.open(OpenUrl);
                    })
                    }
                    
                });
                // that.InApi("api/WaterBill/WaterBill/blueinvoice",{I_KeMu: S_CID, i_FeeId: I_FEEID},"POST",{ timeout: 10000 }).then(function (response) {
                //     that.SpinShow=false;
                //     if(!response)return false;
                //     let ResData = JSON.parse(response);
                //     if (ResData.ReturnCode==false) {
                //         that.$Notice.error({title:'提示',desc: "开票失败，请于12小时后再试"});
                //         return false;
                //     }
                //     if (ResData.data.length<=0) {
                //         that.$Notice.error({title:'提示',desc: "开票失败，请于12小时后再试"});
                //         return false;
                //     }
                //     ResData.data.forEach(n => {
                //         let OpenUrl = n.S_Url;
                //         window.open(OpenUrl);
                //     })
                // });
            },
            OpenInvice(S_CID, I_ZhangWuNY, I_FEEID){
                let _res=this.InApi("api/Invoice/Invoice/GetInvoiceInfo",
                    { S_CID: S_CID, I_ZhangWuNY: I_ZhangWuNY, I_FEEID: I_FEEID},"get");
                return _res;
            },
            AccountPay(){
                let that=this;
                that.InApi("api/WaterBill/WaterBill/GetQRCode",{  S_CID: that.CurrentScid},"get").then(function (response) {
                    if(!response)return false;
                    let _data =response.qrcode;
                    if(!_data) return false;
                    that.QRcodeModal=true;
                    that.QRcode=_data;
                });
            },
            rowClassName(row){
                if (row.I_XiaoZhang==0) {
                    return 'demo-table-error-row';
                }
                return '';
            },
            downloadInvoice(format) {
                console.log(`正在下载${format.toUpperCase()}格式的发票...`);
                // 在这里添加实际的下载逻辑，比如调用API或生成文件等
                // 根据需要处理不同的格式
                switch (format) {
                    case '002':  //002是普票 001是专票
                    this.downloadFile(this.OpenPDFUrl);
                    break;
                    case '001':
                    this.downloadFile(this.OpenOFDUrl);
                    break;
                    default:
                    console.error('未知的下载格式');
                }
            },
            downloadFile(url) {
                console.log(url)
                url.forEach((n,index) => {
                    setTimeout(() => {
                        window.open(n, '_blank');
                    }, index * 1000); // 每隔1秒下载一个文件

                })
            },

        }
    }
</script>

<style>
    .ivu-table .demo-table-error-row td{
        background-color: #187;
        color: #fff;
    }
</style>
